export default __webpack_public_path__ + "static/media/logo__technology__express.910adc86.png";